import React, { useEffect, useState } from 'react';
import axios from 'axios';
import UserPostCard from './UserPostCard';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { isUser } from '../../Config/isUser';
import { isCompany } from '../../Config/isCompany';
import NotFoundPage from '../../Pages/NotFoundPage';
import { isAuth } from '../../Config/isAuthorized';
import { useCategoryContext } from '../../Context/categoryContext';

const categories = [
  "Araştırma Geliştirme (AR-GE)",
  "Geri Ödeme/Pazara Erişim",
  "Klinik Destek/Aplikasyon",
  "Kalite/Belgelendirme/Mevzuat",
  "Lojistik ve Tedarik Zinciri",
  "Pazarlama/Ürün Yönetimi",
  "Satış",
  "Teknik Servis",
  "Teknoloji Yönetimi",
  "Test/Kalibrasyon/Muayene",
  "Üretim",
  "Akademik",
  "Diğer"
];

const cities = [
  "Hepsi","Genel","Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya", "Ankara", "Antalya",
  "Artvin", "Aydın", "Balıkesir", "Bartın", "Batman", "Bayburt", "Bilecik", "Bingöl", "Bitlis",
  "Bolu", "Burdur", "Bursa", "Çanakkale", "Çankırı", "Çorum", "Denizli", "Diyarbakır", "Düzce",
  "Edirne", "Elazığ", "Erzincan", "Erzurum", "Eskişehir", "Gaziantep", "Giresun", "Gümüşhane",
  "Hakkari", "Hatay", "Iğdır", "Isparta", "İstanbul", "İzmir", "Kahramanmaraş", "Karabük", "Karaman",
  "Kastamonu", "Kayseri", "Kırıkkale", "Kırklareli", "Kırşehir", "Kilis", "Kocaeli", "Konya", "Kütahya",
  "Malatya", "Manisa", "Mardin", "Mersin", "Muğla", "Muş", "Nevşehir", "Niğde", "Ordu", "Osmaniye",
  "Rize", "Sakarya", "Samsun", "Siirt", "Sinop", "Sivas", "Şanlıurfa", "Şırnak", "Tekirdağ", "Tokat",
  "Trabzon", "Tunceli", "Uşak", "Van", "Yalova", "Yozgat", "Zonguldak", "Yurt Dışı"
];

const AllPosts = () => {
  const [posts, setPosts] = useState([]);
  const [otherPosts, setOtherPosts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedJobTypes, setSelectedJobTypes] = useState([]);
  const [selectedCity, setSelectedCity] = useState("Hepsi");
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 6;
  const { categoryInfo, setCategoryInfo } = useCategoryContext();

  useEffect(() => {
    const fetchUsers = async () => {
      let activePosts = [];
      let activeOtherPosts = [];
      let activeFastPosts = [];
  
      try {
        const response = await axios.get('https://kariyer.biyomed.net/api/posts/getAllPosts');
        if (response.data.posts) {
          activePosts = response.data.posts.filter(post => post.job_status === 1);
        }
      } catch (error) {
        console.error('Error fetching getAllPosts:', error);
      }
  
      try {
        const res = await axios.get('https://kariyer.biyomed.net/api/admin/getAllOtherPosts', {
          params: { all: 'true', filterStatus: 1 }
        });
        if (res.data.job_listings) {
          activeOtherPosts = res.data.job_listings;
        }
      } catch (error) {
        console.error('Error fetching getAllOtherPosts:', error);
      }

      try {
        const res2 = await axios.get('https://kariyer.biyomed.net/api/posts/get-fast-post');
        
        if (res2.data.posts) {
          activeFastPosts = res2.data.posts.filter(post => post.job_status !== 0);
        }
      } catch (error) {
        console.error('Error fetching getAllOtherPosts:', error);
      }
  
      const sortedPosts = [...activePosts, ...activeOtherPosts, ...activeFastPosts].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
  
      setPosts(sortedPosts);
      setFilteredPosts(sortedPosts);
    };
  
    if (categoryInfo !== '') {
      setSelectedCategories([categoryInfo]);
      setCategoryInfo('');
    }
  
    fetchUsers();
  }, []);
  
  
  

  const filterPosts = () => {
    let filtered = posts;

    if (searchTerm) {
      filtered = filtered.filter(post =>
        post.position_name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (selectedCategories.length > 0) {
      filtered = filtered.filter(post => selectedCategories.includes(post.position_category));
    }

    if (selectedCity !== "Hepsi") {
      filtered = filtered.filter(post => {
        const cities = post.city.split(','); // Şehri virgülle ayır
        return cities.some(city => city.trim().toLowerCase() === selectedCity.toLowerCase()); // Seçilen şehir ile karşılaştır
      });
    }

    if (selectedJobTypes.length > 0) {
      filtered = filtered.filter(post => {
        if (selectedJobTypes.includes("Staj İlanları") && post.job_type.includes("Staj")) return true;
        if (selectedJobTypes.includes("İş İlanları") && post.job_type.includes("Is")) return true;
        return false;
      });
    }

    setFilteredPosts(filtered);
    setCurrentPage(1);
  };

  useEffect(() => {
    filterPosts();
  }, [searchTerm, selectedCategories, selectedCity, posts, selectedJobTypes]);

  const handleCategoryChange = (category) => {
    let updatedCategories = [...selectedCategories];

    if (updatedCategories.includes(category)) {
      updatedCategories = updatedCategories.filter(cat => cat !== category);
    } else {
      updatedCategories.push(category);
    }

    setSelectedCategories(updatedCategories);
  };

  const handleJobTypeChange = (type) => {
    let updatedTypes = [...selectedJobTypes];
  
    if (updatedTypes.includes(type)) {
      updatedTypes = updatedTypes.filter(t => t !== type);
    } else {
      updatedTypes.push(type);
    }
  
    setSelectedJobTypes(updatedTypes);
  };

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = filteredPosts.slice(indexOfFirstPost, indexOfLastPost);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <>{isUser  || isAuth ?  <div className="jp_listing_sidebar_main_wrapper">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="jp_listing_heading_wrapper">
              <h2>
                Sizin için <span>{filteredPosts.length}</span> Eşleşme bulduk
              </h2>
            </div>
          </div>

          {/* SOL TARAF (ŞEHİR & KATEGORİ FİLTRELERİ) */}
          <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 ">
            <div className="row">

                                       {/* İş/Staj Filtresi */}
           <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div className="jp_rightside_job_categories_wrapper">
                    <div className="jp_rightside_job_categories_heading">
                      <h4>İlan Türü</h4>
                    </div>
                    <div className="jp_rightside_job_categories_content">
                      <ul className="category-list">
                        <li>
                          <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                            <input
                              type="checkbox"
                              checked={selectedJobTypes.includes("Staj İlanları")}
                              onChange={() => handleJobTypeChange("Staj İlanları")}
                              style={{ marginRight: '4px' }}
                            />
                            Staj İlanları
                          </label>
                        </li>
                        <li>
                          <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                            <input
                              type="checkbox"
                              checked={selectedJobTypes.includes("İş İlanları")}
                              onChange={() => handleJobTypeChange("İş İlanları")}
                              style={{ marginRight: '4px' }}
                            />
                            İş İlanları
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                              {/* Kategori Filtresi */}
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="jp_rightside_job_categories_wrapper">
                  <div className="jp_rightside_job_categories_heading">
                    <h4>Kategori</h4>
                  </div>
                  <div className="jp_rightside_job_categories_content">
                    <ul className="category-list">
                      {categories.map(category => (
                        <li key={category}>
                          <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                            <input
                              type="checkbox"
                              checked={selectedCategories.includes(category)}
                              onChange={() => handleCategoryChange(category)}
                              style={{ marginRight: '4px' }}
                            />
                            {category}
                          </label>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Şehir Filtresi */}
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="jp_rightside_job_categories_wrapper">
                  <div className="jp_rightside_job_categories_heading">
                    <h4>İl</h4>
                  </div>
                  <div className="jp_rightside_job_categories_content">
                    <select
                      value={selectedCity}
                      onChange={(e) => setSelectedCity(e.target.value)}
                      style={{
                        width: '90%',
                        marginTop:20,
                        padding: '10px',
                        borderRadius: '5px',
                        border: '1px solid #ddd'
                      }}
                    >
                      {cities.map((city) => (
                        <option key={city} value={city}>
                          {city}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>



            </div>
          </div>


          {/* SAĞ TARAF (İLANLAR ve ARAMA) */}
          <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="jp_listing_tabs_wrapper">
                  <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                    <div className="gc_causes_select_box_wrapper">
                      <div className="gc_causes_select_box">
                        <input
                          type="text"
                          placeholder="Pozisyon ara..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          style={{
                            width: '100%',
                            padding: '10px',
                            borderRadius: '5px',
                            border: '1px solid #ddd'
                          }}
                        />
                        <button
                          onClick={filterPosts}
                          style={{
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer'
                          }}
                        >
                          <i className="fa fa-search"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* UserPostCard Listesi */}
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="tab-content">
                  <div id="grid" className="tab-pane fade in active">
                    <div className="row">
                      {currentPosts.length > 0 ? (
                        currentPosts.map((post) => (
                          <UserPostCard  key={post.id} post={post} />
                        ))
                      ) : (
                        <p style={{ textAlign: 'center', width: '100%', marginTop: '20px' }}>
                          Bu kriterlere uygun ilan bulunamadı.
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Sayfalama */}
              {filteredPosts.length > postsPerPage && (
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <Stack spacing={2} alignItems="center" marginTop={3}>
                    <Pagination
                      count={Math.ceil(filteredPosts.length / postsPerPage)}
                      page={currentPage}
                      onChange={handlePageChange}
                      variant="outlined"
                      shape="rounded"
                      color="primary"
                    />
                  </Stack>
                </div>

              )}
            </div>
          </div>
        </div>
      </div>
    </div> : <NotFoundPage/> }</>

  );
};

export default AllPosts;
